/**
 * i18n — locale data and translation messages (ESM for Vite).
 */
import enTranslationMessages from './translations/en.json';
import svTranslationMessages from './translations/sv.json';
import { DEFAULT_LOCALE, appLocales } from './i18n.config.json';

export { DEFAULT_LOCALE, appLocales };

const formatTranslationMessages = (locale, messages) => {
  const defaultFormattedMessages =
    locale !== DEFAULT_LOCALE
      ? formatTranslationMessages(DEFAULT_LOCALE, enTranslationMessages)
      : {};
  const flattenFormattedMessages = (formattedMessages, key) => {
    const formattedMessage =
      !messages[key] && locale !== DEFAULT_LOCALE
        ? defaultFormattedMessages[key]
        : messages[key];
    return Object.assign(formattedMessages, { [key]: formattedMessage });
  };
  return Object.keys(messages).reduce(flattenFormattedMessages, {});
};

const translationMessages = {
  en: formatTranslationMessages('en', enTranslationMessages),
  sv: formatTranslationMessages('sv', svTranslationMessages),
};

export { formatTranslationMessages, translationMessages };
